const trimProcessor = (content: string) => content.trim()

const trimWhitespaceBeforeTagsProcessor = (content: string): string => {
  // Remove whitespace before closing tags
  return content.replace(/(\s+)(<\/[^>]+>)/g, (match, spaces, closingTag) => {
    return closingTag // Remove all spaces before closing tags
  })
}

const convertLinksProcessor = function processOrphanLinks(
  content: string
): string {
  // First, temporarily replace existing <a> tags with a placeholder
  const placeholders: { [key: string]: string } = {}
  let counter = 0

  const contentWithoutATags = content.replace(
    /<a\s+[^>]*>.*?<\/a>/g,
    (match) => {
      const placeholder = `__LINK_PLACEHOLDER_${counter}__`
      placeholders[placeholder] = match
      counter++
      return placeholder
    }
  )

  // Find all URLs and create placeholders for them
  const urlRegex = /https?:\/\/[^\s<>,()[\]{}'"]+\b/g

  const contentWithNewATags = contentWithoutATags.replace(urlRegex, (url) => {
    return `<a href="${url}" title="${url}">${url}</a>`
  })

  // Restore original <a> tags
  const finalContent = contentWithNewATags.replace(
    /__LINK_PLACEHOLDER_\d+__/g,
    (placeholder) => placeholders[placeholder]
  )

  return finalContent
}

export const processArticleContent = (content: string): string => {
  const processors = [
    trimProcessor,
    trimWhitespaceBeforeTagsProcessor,
    convertLinksProcessor,
  ]

  return processors.reduce((acc, processor) => processor(acc), content)
}
